import { inject } from '@angular/core';
import { CanActivateFn, RedirectCommand, Router } from '@angular/router';
import { AdminRoleStr, CompanyRoleStr, IndividualRoleStr, UserService } from './user.service';

export function getRoleHomeUrl(role: string): string {
  switch (role) {
    case AdminRoleStr:
      return '/admin';
    case CompanyRoleStr:
      return '/company';
    case IndividualRoleStr:
      return '/individual';
    default:
      return '/authentication/login';
  }
}

export const rootRedirectGuard: CanActivateFn = () => {
  const router = inject(Router);
  const role = inject(UserService).getUserData.role;
  return new RedirectCommand(router.parseUrl(getRoleHomeUrl(role)));
};
